export default __webpack_public_path__ + "static/media/splash-image-04.effa4e05.png";